import PropTypes from 'prop-types';
import { Field } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import { DropzoneArea } from 'material-ui-dropzone';
import theme from '../../theme';

const useStyles = makeStyles(() => ({
  label: {
    display: 'block',
    marginBottom: theme.spacing(1),
  },
}));

const DropzoneFileField = (props) => {
  const { name, label, disabled, touched, className, ...rest } = props;
  const classes = useStyles();
  return (
    <Field name={name}>
      {({ field, form }) => {
        const error = (touched || form.touched[name]) && Boolean(form.errors[name]);
        return (
          <div className={className}>
            {label && <FormLabel className={classes.label} for={name}>{label}</FormLabel>}
            <DropzoneArea
              initialFiles={field.value}
              onChange={(files) => {
                form.setFieldValue(name, files);
                form.setFieldTouched(name, true);
              }}
              disabled={disabled}
              maxFileSize={20000000} // 20mb
              {...rest}
            />
            {error && <p className={classes.error}>{error}</p>}
          </div>
        );
      }}
    </Field>
  );
};

DropzoneFileField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  filesLimit: PropTypes.number,
};

DropzoneFileField.defaultProps = {
  filesLimit: 3,
};

export default DropzoneFileField;
